import { Empty } from "antd"
import React from "react"
import { Button } from "@/components/ui/button"
import { ReloadOutlined } from "@ant-design/icons"

interface Props {
  handleReset: () => void
}

const EmptyData = ({ handleReset }: Props) => {
  return (
    <Empty description="Data tidak tersedia" style={{ marginTop: 40 }}>
      <Button onClick={handleReset}>
        <ReloadOutlined />
        Reset Filter
      </Button>
    </Empty>
  )
}

export default EmptyData
